import { z } from 'zod'

export const GoodlokPreferences = z.object({
	level: z.number(),
})

export type GoodlokPreferences = z.infer<typeof GoodlokPreferences>
